/* Courted · This week: each time you're both free in the next seven days (from Home's week) with one idea from
   the ones you both like that suits it — dinner or drinks in the evening, outdoors in daylight — with Plan it
   and Something else. What's already planned from Courted sits on top. With the weather (T3): each daylight
   time shows the forecast; the first fine one with three hours of daylight "looks good for a hike", with
   Find a spot; a planned outdoor date that's turned wet says so. Your partner's dates for you both ask first
   (0045): I'm in, or Can't make it; yours say whether they're in. */
import React from 'react';
import * as H from './helpers.js';
import { Ico, Plate, Google, Wx, track } from './ui.jsx';
import * as W from './weather.js';

const { useState } = React;
const DOW = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const dayLabel = (iso, today) => { if (iso === today) return 'Today'; if (iso === H.addDays(today, 1)) return 'Tomorrow'; const d = new Date(iso + 'T12:00:00'); return DOW[d.getDay()] + ' ' + d.getDate(); };

/* `who`: what's been said about it — 'both' (you both like it), 'loved' (a favourite), or `mine` (yours to suggest:
   your partner hasn't seen it yet, and Plan it asks them). */
function Idea({ id, card, cat, kind, onOpen, both, solo, idea, partner }) {
  const who = !idea ? (both ? (solo ? 'You said yes' : 'You both like it') : null)
    : idea.mine ? (partner ? partner.name + ' hasn’t seen it yet' : 'You said yes')
    : idea.loved === 'both' ? 'You both loved it' : idea.loved ? 'A favourite' : solo ? 'You said yes' : 'You both like it';
  return (
    <button type="button" className="co-idea" onClick={() => onOpen(id)}>
      <Plate card={card} kind={kind} load className="th" />
      <span className="tx"><b>{(cat && cat.name) || (card && card.name) || '\u00a0'}</b>
        <small>{card ? H.cardLine(card, cat) : '\u00a0'}</small>
        {who ? <span className={'co-who' + (idea && idea.mine ? ' mine' : '')}><Ico n={idea && idea.mine ? 'i-info' : 'i-heart-f'} s />{who}</span> : null}</span>
    </button>
  );
}

const POSTER = (p) => 'https://image.tmdb.org/t/p/w342' + p;
/* In theatres (In cinemas, In theaters): the films showing near you that you both said yes to in Curated;
   none of them, what's on, with Swipe what's on (Curated's deck, just those films). */
function InTheatres({ t, words, partner, onFilm, onSwipeOn }) {
  if (!t || !t.showing.length) return null;
  const list = t.both.length ? t.both.slice(0, 3) : t.showing;
  return (
    <section className="dv-card co-films" aria-labelledby="co-films-h">
      <div>
        <h2 id="co-films-h" className="co-display">{words.films}</h2>
        <p>{t.both.length ? 'Showing near you, from the films you ' + (partner ? 'both ' : '') + 'said yes to.' : 'Nothing you’ve ' + (partner ? 'both ' : '') + 'said yes to is showing. What’s on near you:'}</p>
      </div>
      <div className="co-posters">
        {list.map((f) => (
          <button key={f.id} type="button" onClick={() => onFilm(f.id)}>
            {f.poster ? <img src={POSTER(f.poster)} alt="" loading="lazy" /> : <span className="none" />}
            <b>{f.title}</b><small>{H.filmLine(f)}</small>
          </button>
        ))}
      </div>
      {t.both.length ? null : <button type="button" className="dv-btn dv-btn-soft" onClick={onSwipeOn}>Swipe what’s on</button>}
      <p className="co-tmdb">Films from TMDB</p>
    </section>
  );
}

const DOWS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
/* "Last night" / "Yesterday" / "Friday": when a date that's been was. */
export function wasWhen(p, today) {
  if (p.on_date === H.addDays(today, -1)) return p.start_time && p.start_time < '17:00' ? 'Yesterday' : 'Last night';
  return DOWS[new Date(p.on_date + 'T12:00:00').getDay()];
}

export function WeekR({ web, slots, picks, planned: all, cardsById, catById, today, partner, weekKnown, sunsetFor, words, theatres, onFilm, onSwipeOn, onPlan, onOpen, onSwipe, wx, chance, country, kindOfPlan, onSpot, ideas = [], onSwap, meId, onRespond, rate = [], onRate, searchLabel, onSearch }) {
  const [alt, setAlt] = useState({});
  const solo = !partner;
  // your partner's dates for you both that wait on your answer, then everything else that's planned
  const asks = all.filter((p) => p.who !== 'me' && p.created_by && p.created_by !== meId && !p.agreed_by);
  const planned = all.filter((p) => !asks.includes(p));
  const at = (p) => (p.start_time ? H.ampm(Number(p.start_time.slice(0, 2)) * 60 + Number(p.start_time.slice(3, 5))) : '');
  const status = (p) => (p.who === 'me' || solo ? '' : p.agreed_by ? ' · you’re both in' : p.created_by === meId ? ' · waiting for ' + partner.name : '');
  const lede = H.weekLede(slots.length, 0);
  const plannedDates = new Set(all.map((p) => p.on_date));
  // a planned date's name: ours, or Google's live (only the place's id is kept), or what the plan says
  const nameOf = (p) => { const id = p.ref && p.ref.place && p.ref.place.id; return (id && catById[id] && catById[id].name) || (id && cardsById[id] && cardsById[id].name) || p.title; };
  // a planned hike that's turned wet: somewhere inside you both like instead
  const wetPlans = wx ? planned.filter((p) => kindOfPlan(p) === 'outdoors' && W.wetDay(wx[p.on_date])) : [];
  const [inside, setInside] = useState({});
  return (
    <div className="co-main">
      {/* Go out anywhere: search near home, or in the town you're looking at (Discover › Go out) */}
      {onSearch ? <button type="button" className="dv-field co-searchfield" onClick={onSearch}><Ico n="i-search" s /><span>{searchLabel || 'Search places'}</span></button> : null}
      {rate.slice(0, 3).map((p) => {
        const pid = p.ref.place.id;
        return (
          <section key={'how' + p.id} className="co-slot co-howcard" aria-label={'How was ' + wasWhen(p, today).toLowerCase() + '?'}>
            <div className="when"><b>How was it?</b><span className="t">{wasWhen(p, today)}</span></div>
            <Idea id={pid} card={cardsById[pid]} cat={catById[pid]} kind={kindOfPlan(p)} onOpen={onOpen} />
            <div className="acts">
              <button type="button" className="dv-pill dv-pill-pop" onClick={() => onRate(p, 'loved')}><Ico n="i-heart-f" s />Loved it</button>
              <button type="button" className="dv-quiet" onClick={() => onRate(p, 'never')}>Wouldn’t go again</button>
            </div>
          </section>
        );
      })}
      {asks.map((p) => {
        const pid = p.ref && p.ref.place && p.ref.place.id;
        const kind = kindOfPlan(p);
        return (
          <section key={'ask' + p.id} className="co-slot co-ask" aria-label={partner.name + '’s up for a date ' + dayLabel(p.on_date, today)}>
            <div className="when"><b>{dayLabel(p.on_date, today)}</b>{p.start_time ? <span className="t">{'At ' + at(p)}</span> : null}</div>
            <p className="co-good"><b>{partner.name}’s up for it</b> · Are you in?</p>
            {pid ? <Idea id={pid} card={cardsById[pid]} cat={catById[pid]} kind={kind} onOpen={onOpen} /> : null}
            <div className="acts">
              <button type="button" className="dv-pill dv-pill-pop" onClick={() => onRespond(p, 'in')}>I’m in</button>
              <button type="button" className="dv-quiet" onClick={() => onRespond(p, 'out')}>Can’t make it</button>
            </div>
          </section>
        );
      })}
      {planned.length ? (
        <section className="co-sec co-planned">
          <h2 className="co-display co-h2">Planned</h2>
          <div className="dv-list dv-list-inset">
            {planned.map((p) => {
              const pid = p.ref && p.ref.place && p.ref.place.id;
              const d = wx && wx[p.on_date];
              const outdoors = kindOfPlan(p) === 'outdoors';
              return (
                <button key={p.id} type="button" className="dv-row co-prow" onClick={() => pid && onOpen(pid)}>
                  <span className="co-ptile"><small>{dayLabel(p.on_date, today).split(' ')[0].slice(0, 3)}</small><b>{new Date(p.on_date + 'T12:00:00').getDate()}</b></span>
                  <span className="dv-row-text"><span>{nameOf(p)}</span><small>{dayLabel(p.on_date, today)}{p.start_time ? ' · ' + at(p) : ''}{p.who === 'me' ? ' · just you' : status(p)}</small>
</span>
                  {outdoors && d ? <Wx d={d} country={country} /> : null}
                  <Ico n="i-chevron" s />
                </button>
              );
            })}
          </div>
        </section>
      ) : null}
      {wetPlans.map((p) => {
        const picks2 = H.indoorPicks(ideas, planned.filter((x) => x.on_date === p.on_date).map((x) => x.ref && x.ref.place && x.ref.place.id));
        const pick = picks2.length ? picks2[(inside[p.id] || 0) % picks2.length] : null;
        return (
          <section key={'wet' + p.id} className="co-slot co-rain" aria-label={W.wetWords(W.wetDay(wx[p.on_date]), p.on_date, today, words.hike)}>
            <div className="when"><b>{W.wetWords(W.wetDay(wx[p.on_date]), p.on_date, today, words.hike)}</b><Wx d={wx[p.on_date]} country={country} /></div>
            <p className="co-good">{pick ? 'Somewhere inside instead of ' + nameOf(p) + '?' : 'Nothing inside you ' + (solo ? '' : 'both ') + 'like yet.'}</p>
            {pick ? <Idea id={pick.id} card={cardsById[pick.id]} cat={catById[pick.id]} kind={pick.kind} onOpen={onOpen} both solo={solo} /> : null}
            <div className="acts">
              {pick ? <button type="button" className="dv-pill dv-pill-pop" onClick={() => onSwap(p, pick.id)}>Swap for it</button>
                : <button type="button" className="dv-pill dv-pill-pop" onClick={onSwipe}>Swipe for ideas</button>}
              {picks2.length > 1 ? <button type="button" className="dv-quiet" onClick={() => { setInside({ ...inside, [p.id]: (inside[p.id] || 0) + 1 }); track('courted_something_else', { from: 'rain' }); }}>Something else</button> : null}
            </div>
          </section>
        );
      })}
      {!weekKnown ? (
        <div className="co-lede"><h2 className="co-display">This week</h2><p>{web ? 'When you’re both free comes from your week, in the Domovoi app. Here, Plan it on any idea picks a day.' : 'Your free times show here once Home has worked out the week. Meanwhile, Plan it on any idea picks a day.'}</p></div>
      ) : solo ? (
        <div className="co-lede"><h2 className="co-display">Better with two</h2><p>When your partner joins, the times you’re both free show here, each with an idea you both like. <a href="/join/">Invite your partner</a></p></div>
      ) : (
        <div className="co-lede"><h2 className="co-display">{lede.head}</h2><p>{lede.sub}</p></div>
      )}
      {chance && !slots.some((x) => x.date === chance.date) ? (
        <section className="co-slot good" aria-label={W.dayName(chance.date, today)}>
          <div className="when"><b>{W.dayName(chance.date, today)}</b><span className="t">{'From ' + H.ampm(chance.from)}</span><Wx d={chance.day} country={country} /></div>
          <p className="co-good"><b>Looks good for a {words.hike}</b> · {W.weatherWords(chance.day, country)}</p>
          <div className="acts"><button type="button" className="dv-pill dv-pill-pop" onClick={() => onSpot(chance.date, 'week')}>Find a spot</button></div>
        </section>
      ) : null}
      {picks.map(({ slot, idea, alts }, k) => {
        // one idea each; with none left for this time, Something else offers the ones already suggested
        const n = alt[k] || 0;
        const list = idea ? [idea, ...alts] : alts;
        const show = idea || n ? list[(idea ? n : n - 1) % list.length] : null;
        const kind = show ? H.kindOf(show.id, catById[show.id], cardsById[show.id], show.kind) : null;
        const sun = sunsetFor(slot.date);
        const outdoorsDay = slot.all || (sun != null && sun - slot.from >= 120);
        const cat = show ? catById[show.id] : null;
        const d = wx && wx[slot.date];
        const good = chance && chance.date === slot.date;
        return (
          <section key={slot.date} className={'co-slot' + (good ? ' good' : '')} aria-label={slot.label}>
            <div className="when"><b>{slot.label}</b><span className="t">{slot.when}</span>{plannedDates.has(slot.date) ? <span className="dv-tag co-tag-planned">Something’s planned</span> : null}
              {d && outdoorsDay ? <Wx d={d} country={country} /> : null}</div>
            {good ? <p className="co-good"><b>Looks good for a {words.hike}</b> · {W.weatherWords(d, country)}</p> : null}
            {slot.kids ? <p className={'co-kids' + (slot.sitter ? '' : ' free')} data-private><Ico n={slot.sitter ? 'i-info' : 'i-heart'} s />{slot.kids}</p> : null}
            {show ? <Idea id={show.id} card={cardsById[show.id]} cat={cat} kind={kind} onOpen={(id) => onOpen(id, slot.date)} both solo={solo} idea={show} partner={partner} /> : (
              <p className="co-none">{outdoorsDay ? 'Nothing you both like fits yet. A walk, a gallery, a long lunch?' : 'Nothing you both like for an evening yet.'}</p>
            )}
            {show && H.bookingLive(cat, today) ? <span className="co-bnote"><Ico n="i-info" s />{cat.booking_note}{cat.booking_until ? ' until ' + H.shortDate(cat.booking_until, country) : ''}</span> : null}
            <div className="acts">
              {show ? <button type="button" className="dv-pill dv-pill-pop" onClick={() => onPlan(show.id, slot.date)}>Plan it</button>
                : <button type="button" className="dv-pill dv-pill-pop" onClick={() => onSwipe(slot.date)}>Swipe for {slot.date === today ? 'tonight' : slot.dow}</button>}
              {(idea ? list.length > 1 : list.length > 0) ? <button type="button" className="dv-quiet" onClick={() => { setAlt({ ...alt, [k]: n + 1 }); track('courted_something_else', {}); }}>{show ? 'Something else' : 'Show one anyway'}</button> : null}
              {good ? <button type="button" className="dv-quiet" onClick={() => onSpot(slot.date, 'week')}>Find a spot</button> : null}
            </div>
          </section>
        );
      })}
      <InTheatres t={theatres} words={words} partner={partner} onFilm={onFilm} onSwipeOn={onSwipeOn} />
      <Google weather={!!wx} />
    </div>
  );
}
